<template>
  <div class="vx-row">
    <vx-card>
      <vs-row vs-w="12">
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
          <vs-button icon="keyboard_backspace" @click="goBack">Back</vs-button>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="10"
          vs-sm="4"
          vs-xs="12"
        >
          <h3>Campaigns - Request Contact</h3>
        </vs-col>
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
      </vs-row>

      <ClientDataGrid
              :key="companySDContactComponentKey"
              ref="RequestAccountsCampaignsDataGrid"
              :columnDefs="campaignsColumnDefs"
              :rowData="campaignsRecords"
            >
            </ClientDataGrid>



<!-- 
      <DataGrid :context="'CampaignsOfGrade3RebuildDataGrid'" 
        ref="campaignsList"
        :columnDefs="campaignsColumnDefs"
        :rowData="campaignsRecords"
        :dataSource="campaignsDataSource"
        @goToLiveSDDashboard="goToLiveSDDashboard"
        @goToLiveSalesDeveloperDefaultViews="goToLiveSalesDeveloperDefaultViews"

        
      >
      </DataGrid> -->
    </vx-card>
  
  </div>
</template>

<script>
import defineAbilitiesFor from "@/config/abilities";
import ClientDataGrid from "@/components/aggrid/AggridClient.vue";
import moduleCampaignManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import vSelect from "vue-select";
export default {
  data: () => ({
                companySDContactComponentKey:0,
    selected_default_view : null,
    user_id : null,
    sd_view_options : [],
    showHideEditSDDefaultViewPopup : false,
    abilities: null,
    campaignsColumnDefs: [
      {
        headerName: "Actions",
        field: "transactions",
        cellRenderer: "CellRendererActions",
        suppressHeaderMenuButton: true,
        pinned: true,
        width: 60
      },
      {
        headerName: "Campaign",
        field: "campaign_name",
        flex: 1,
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      {
        headerName: "Campaign Code",
        field: "campaign_code",
        flex: 1,
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      {
        headerName: "Start Date",
        field: "start_date",
        flex: 1,
        filter: "agDateColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4,
                           comparator: (filterLocalDateAtMidnight, cellValue) => {
            if (cellValue === null) return -1; // Handle null or empty cell values

            // Convert string cellValue to a Date object
            const cellDate = new Date(cellValue); 

            // Compare the dates
            if (cellDate.getTime() === filterLocalDateAtMidnight.getTime()) {
              return 0;
            }
            if (cellDate < filterLocalDateAtMidnight) {
              return -1;
            }
            if (cellDate > filterLocalDateAtMidnight) {
              return 1;
            }
            return 0; // Fallback
          },
        }
      },
      {
        headerName: "End Date",
        field: "end_date",
                flex: 1,
        filter: "agDateColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4,
                           comparator: (filterLocalDateAtMidnight, cellValue) => {
            if (cellValue === null) return -1; // Handle null or empty cell values

            // Convert string cellValue to a Date object
            const cellDate = new Date(cellValue); 

            // Compare the dates
            if (cellDate.getTime() === filterLocalDateAtMidnight.getTime()) {
              return 0;
            }
            if (cellDate < filterLocalDateAtMidnight) {
              return -1;
            }
            if (cellDate > filterLocalDateAtMidnight) {
              return 1;
            }
            return 0; // Fallback
          },
        }
      },
    
    ],
    campaignsRecords: [],
    selected_campaign: null
  }),
  components: {
    "v-select": vSelect,
    ClientDataGrid
  },
  watch: {},
  methods: {

  

    updateSalesDeveloperDefaultViewAction(){
      console.log(this.selected_default_view)


      let self = this

      let data = {}
      data.campaign_id = self.selected_campaign_id
      data.user_id = self.user_id;
      if(this.selected_default_view){
        data.selected_default_view_id = this.selected_default_view.id
      }

      if (data.selected_default_view_id){


      self.$store
      .dispatch(
        'campaignsManagement/updateSalesDeveloperDefaultViewAction',
        data
      )
      .then(res => {
        if (res) {
          if (res.data.status == 'success') {
            location.reload();

          }
        }
      })
      .catch(err => {
        console.log(err)
      })



      }

    


    },
    goToLiveSalesDeveloperDefaultViews(data){
      this.selected_campaign_id = data.campaign_id
      console.log(data)
    },
    sdDashboard() {
      this.$router.replace("/sales-developer-dashboard/view/" + this.selected_campaign.campaign_id + '/' + btoa(this.selected_campaign.campaign_name));
    //  alert("got to")
    },
    goToLiveSDDashboard(value) {
      this.selected_campaign = value;
      this.selected_campaign_id = value.campaign_id;
      this.sdDashboard();
    },
   getcampaignDataSource() {
      var self = this;
      self.$vs.loading();

      let data = {};
      data.user_id = self.user_id;
      self.$store
        .dispatch("campaignsManagement/getCampaignsOfContactRequest", data)
        .then(function(response) {
          let response_data = response.data;

       



          

          

          self.campaignsRecords = response_data;


          console.log("Grade 3 Rebuild Records" , self.campaignsRecords)

          self.$vs.loading.close();

        })
        .catch(err => {
          console.error(err);
        });


    },
 
    goBack: function() {
      this.$router.go(-1);
    }
  },
  beforeMount() {
  },
  mounted() {
        this.getcampaignDataSource();

  },
  created() {
    var self = this;
    defineAbilitiesFor().then(function(data) {
      self.abilities = data;
    });
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    self.user_id = userInfo["uid"];
    if (!moduleCampaignManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignManagement
      );
      moduleCampaignManagement.isRegistered = true;
    }
  }
};
</script>
<style scoped>
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table
  .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .tr-values .vs-table--td {
  padding: 15px 15px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  padding: 25px 15px;
  font-weight: 600;
  font-size: 14px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  width: 325px !important;
}

.searchbox {
  margin-left: 5px;
  width: 600px;
}

.filter {
  width: 300px;
}

.pointer {
  cursor: pointer;
}

.item.expanded {
  background-color: white !important;
  color: black !important;
}

.tr-table-state-primary,
.vs-table-primary .is-selected {
  background: none !important;
  box-shadow: none !important;
}

.tr-table-state-primary,
.vs-table-primary .is-selected {
  color: #626262 !important;
  -webkit-box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
  box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
}

.pointer {
  cursor: pointer;
}

.address_th {
  padding: 30px;
}

.address_td {
  padding: 30px;
  font-weight: 500;
}

</style>

<style lang="stylus">
.con-expand-Fields
  .con-btns-Fields
    display flex
    padding 10px
    padding-bottom 0px
    align-items center
    justify-content space-between
    .con-Fieldsx
      display flex
      align-items center
      justify-content flex-start
  .list-icon
    i
      font-size .9rem !important
</style>
